import { UserRole } from "@/shared/enums/UserRole";
import { useHasRole } from "./useHasRole";

export function useHasMcpAccess(): boolean {
  const hasAdminRole = useHasRole(UserRole.Admin);
  const hasMcpToolsEnabled = useHasRole(UserRole.McpToolsEnabled);

  return hasAdminRole || hasMcpToolsEnabled;
}
